GameView    = require("views/base/game")
container   = require("./components/container")
Preloader   = require("lib/preload")

class GameImageWordMatchView extends GameView
  template: require("./template")

  events: ->
    "iostap .play-game": "enterGame"
    "iostap .goto-next": "next"
    "iostap  .btn-word": "checkAnswer"

  initializeData: ->
    super

    @game.extra.set("fullscreen", true)
    @game.extra.set("sounds", true)

    images = _.chain(@options.data.images)
      .map((m) ->
        m.imageType = "image" if not m.imageType or m.imageType is ""
        m
      )
      .filter((m) -> m.title and m.title isnt "")
      .value()
    @setArray images, "images"
    toLoad = _.chain(images).where({imageType: "image"}).pluck("image").value()

    return unless toLoad.length

    Preloader.load toLoad, (errors) =>
      @setArray _.reject(images, (m) -> errors.indexOf(m.image) > -1), "images"

  initializeElements: ->
    super
    @setEl @findOne(".game-box"), "container"

  startGame: ->
    @game.timer.timestamp = Date.now()
    @answeredCount = 0

    super

  showNext: (isFirstRun) ->
    image = @getRandom("images")

    @game.timer.timestamp = Date.now()

    @getEl("container").innerHTML = container _.extend {}, @options.data,
      image: image
      words: _.chain(@getArray("images"))
        .pluck("title")
        .without(image.title)
        .uniq()
        .sample(2)
        .concat(image.title)
        .shuffle()
        .value()

    @getEl("container").offsetTop
    @getEl("container").classList.remove("hidden")

  checkAnswer: (e) ->
    return if @game.timer.get("paused")

    {word, isCorrect} = e.currentTarget.dataset

    if isCorrect?
      @onCorrectAnswer(score: 500, time: 1000, tally: true)
    else
      @onIncorrectAnswer(time: 300, tally: true)

    @getEl("container").classList.add("hidden")

    @answeredCount += 1

    window.setTimeout (=>
      if @game.timer.get("isDisabled") and @answeredCount is @getArray("images").length
        @endGame()
        return

      @showNext()
    ), 1200

module.exports = GameImageWordMatchView
